import { render, staticRenderFns } from "./index.vue?vue&type=template&id=67e6dfac&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=67e6dfac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e6dfac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67e6dfac')) {
      api.createRecord('67e6dfac', component.options)
    } else {
      api.reload('67e6dfac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=67e6dfac&scoped=true", function () {
      api.rerender('67e6dfac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/permission/index.vue"
export default component.exports